import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { ExternalLink, Loader2 } from "lucide-react";
import { BillingStatusBadge } from "./billing-status-badge";

interface Props {
  member: {
    memberId: number;
    memberName: string;
    memberMobile?: string;
    planName: string;
    billingCycleDay: number;
    periodStart: string;
    periodEnd: string;
    draftSubtotal: number;
    draftTotal: number;
    existingInvoiceId: number | null;
  };
  onSend: () => void;
  onSkip: () => void;
  onPreview: () => void;
  isSending: boolean;
}

export function BillingTodayCard({ member, onSend, onSkip, onPreview, isSending }: Props) {
  const sent = member.existingInvoiceId != null;
  return (
    <Card className="mb-4">
      <CardHeader className="flex flex-row items-center justify-between border-b">
        <div className="flex flex-col">
          <div className="text-sm font-semibold">
            MEM-{String(member.memberId).padStart(4, "0")} · {member.memberName} · {member.planName}
          </div>
          <div className="text-xs text-muted-foreground">
            Billing cycle day {member.billingCycleDay} · Period: {member.periodStart} — {member.periodEnd}
          </div>
        </div>
        <div className="flex gap-2 items-center">
          {sent ? <BillingStatusBadge status="Billed" /> : null}
          <Button variant="ghost" size="sm" onClick={onPreview}>
            <ExternalLink className="h-4 w-4 mr-1" /> Preview
          </Button>
          <Button variant="outline" size="sm" onClick={onSkip} disabled={sent}>
            Skip Member
          </Button>
          <Button size="sm" onClick={onSend} disabled={sent || isSending}>
            {isSending ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : null}
            Send Invoice
          </Button>
        </div>
      </CardHeader>
      <CardContent className="text-sm">
        <div className="flex justify-between">
          <span>Draft Subtotal (excl. GST)</span>
          <span className="font-mono">Rs. {member.draftSubtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between border-t pt-2 mt-2">
          <span className="font-semibold">Draft Total</span>
          <span className="font-mono font-semibold text-xl">Rs. {member.draftTotal.toFixed(2)}</span>
        </div>
        <div className="text-xs text-muted-foreground mt-2">WhatsApp: {member.memberMobile ?? "—"}</div>
      </CardContent>
    </Card>
  );
}
